import { render, staticRenderFns } from "./SearchResultConversationsList.vue?vue&type=template&id=801bfa64&"
import script from "./SearchResultConversationsList.vue?vue&type=script&lang=js&"
export * from "./SearchResultConversationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports